import { Node, NodeProps } from "@xyflow/react";
import { DefaultNodeData } from "@zapier/canvas-state";
import { DEFAULT_TABLE_NODE_COLOR } from "@zapier/canvas-constants";

import { AssetNodeProps } from "../../nodeTypes/AssetNodeSkeleton/AssetNodeDeterminer";
import { AssetNodeSkeleton } from "../AssetNodeSkeleton";
export function TableNode(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const { isViewOnlyMode } = props;
  return (
    <AssetNodeSkeleton
      {...props}
      data={{
        ...props.data,
        color: props.data.color || DEFAULT_TABLE_NODE_COLOR,
      }}
      placeholder={isViewOnlyMode ? "" : "Enter Table title"}
      iconName="navTables"
    />
  );
}
